import { translate } from '../../../../common/helpers/translate.helper';
import { useOpenFreshchat } from '../../../../common/hooks/useOpenFreshchat';
import { InteractiveTranslation } from '../../../../common/InteractiveTranslation';

export const WebhookDescription = () => {
    const openFreshchat = useOpenFreshchat();

    return <InteractiveTranslation translation={translate('webhooks.description')} onClick={openFreshchat} />;
};
